define('app/directives.js',[], function() { 
    var directives = {};

    return directives;
});

